import axios from "./axios";

export const trainingRequestKey = () => globalThis.crypto?.randomUUID?.() || `training-${Date.now()}-${Math.random().toString(36).slice(2)}`;
const get = (path, params) => axios.get(`/training${path}`, { params }).then((response) => response.data);
const post = (path, payload = {}) => axios.post(`/training${path}`, payload).then((response) => response.data);
export const trainingApi = {
  options: (params) => get("/options", params),
  guides: (params) => get("/guides", params),
  guide: (id) => get(`/guides/${id}`),
  dependencyIssues: (id, params) => get(`/guides/${id}/dependency_issues`, params),
  createGuide: (payload) => post("/guides", payload),
  updateGuide: (id, payload) => axios.patch(`/training/guides/${id}`, payload).then((response) => response.data),
  newRevision: (id, payload) => post(`/guides/${id}/revisions`, payload),
  copyGuide: (id, payload) => post(`/guides/${id}/copy`, payload),
  preview: (id, payload) => payload ? post(`/guides/${id}/preview`, payload) : get(`/guides/${id}/preview`),
  revisionDiff: (id, params) => get(`/guides/${id}/revision_diff`, params),
  audiencePreview: (id, params) => get(`/guides/${id}/audience_preview`, params),
  translate: (id, payload) => post(`/guides/${id}/translate`, payload),
  publish: (id, payload) => post(`/guides/${id}/publish`, payload),
  deactivate: (id, payload) => post(`/guides/${id}/deactivate`, payload),
  reactivate: (id, payload) => post(`/guides/${id}/reactivate`, payload),
  archive: (id, payload) => post(`/guides/${id}/archive`, payload),
  assignments: (params) => get("/me/assignments", params),
  history: (params) => get("/me/history", params),
  completion: (id) => get(`/me/history/${id}`),
  gate: () => get("/gate"),
  assignment: (id) => get(`/assignments/${id}`),
  start: (id, payload) => post(`/assignments/${id}/start`, payload),
  respond: (id, payload) => post(`/assignments/${id}/responses`, payload),
  language: (id, payload) => post(`/assignments/${id}/language`, payload),
  complete: (id, payload) => post(`/assignments/${id}/complete`, payload),
  snooze: (id, payload) => post(`/assignments/${id}/snooze`, payload),
  document: (id, cardKey) => get(`/assignments/${id}/document`, { card_key: cardKey }),
  image: (id, cardKey) => get(`/assignments/${id}/image`, { card_key: cardKey }),
  reports: (params) => get("/reports", params),
  reportGuides: (params) => get("/report_guides", params),
  deliveries: (params) => get("/deliveries", params),
  audit: (params) => get("/audit", params),
  assignmentAudit: (id, params) => get(`/assignments/${id}/audit`, params),
  assignmentEvidence: (id, params) => get(`/assignments/${id}/evidence`, params),
  exempt: (id, payload) => post(`/assignments/${id}/exempt`, payload),
  extendDeadline: (id, payload) => post(`/assignments/${id}/extend_deadline`, payload),
  exportReport: (params) => axios.get("/training/exports", { params, responseType: "blob" }).then((response) => response.data),
};
export default trainingApi;
